import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { getRouteLink, getStaticPageLink, constructArtificialLinkNode } from "../../../utils/links";
import { stripLanguageFromPathname } from "../../../utils/languages";
import LinkWrapper from "../linkWrapper/LinkWrapper";

const Breadcrumb = ({ currentLanguageCode }) => {
    const location = useLocation();
    let pathname = location.pathname;

    // Remove language prefix if present
    pathname = stripLanguageFromPathname(pathname, currentLanguageCode);

    // Split the path into segments, filter out empty strings
    const pathnames = pathname.split("/").filter((x) => x);

    return (
        <div className="breadcrumb-area pt-35 pb-35 bg-gray-3">
            <div className="container">
                <div className="breadcrumb-content text-center">
                    {pathnames.map((name, index) => {
                        const routeTo = `${pathnames[index]}`;
                        const isFirst = index === 0;
                        const isLast = index === pathnames.length - 1;

                        // Capitalize the first letter for display and replace dashes
                        const displayName = name.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

                        return (
                            <Fragment key={routeTo}>
                                {/* Add the separator */}
                                {!isFirst && <span className="separator"> / </span>}
                                {isLast ? (
                                    // The final item is a span, not a link
                                    <span className="active">{displayName}</span>
                                ) : (
                                    <LinkWrapper
                                        linkNode={constructArtificialLinkNode({
                                            value: isFirst ? getStaticPageLink("HOME") : getRouteLink(routeTo),
                                        })}
                                    >
                                        {displayName}
                                    </LinkWrapper>
                                )}
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default connect()(multilanguage(Breadcrumb));
